// extracted by mini-css-extract-plugin
export default {"selected":"steps-icon_selected__ZeNcJ","stepName":"steps-icon_stepName__tKdHq","unselected":"steps-icon_unselected__F+1Pe","dash":"steps-icon_dash__MJBHf"};